/**
 * @generated SignedSource<<85ec139216c03bd16ddea32396e67044>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type BuildStatusWidgetQuery$variables = {
  btLocator: string;
};
export type BuildStatusWidgetQuery$data = {
  readonly buildType: {
    readonly externalStatusAllowed: boolean | null | undefined;
  } | null | undefined;
};
export type BuildStatusWidgetQuery = {
  response: BuildStatusWidgetQuery$data;
  variables: BuildStatusWidgetQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "btLocator"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "btLocator",
    "variableName": "btLocator"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalStatusAllowed",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BuildStatusWidgetQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BuildTypeRest",
        "kind": "LinkedField",
        "name": "buildType",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BuildStatusWidgetQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BuildTypeRest",
        "kind": "LinkedField",
        "name": "buildType",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a38890821b9e4d4b6d1de09777c63a11",
    "id": null,
    "metadata": {},
    "name": "BuildStatusWidgetQuery",
    "operationKind": "query",
    "text": "query BuildStatusWidgetQuery(\n  $btLocator: String!\n) {\n  buildType(btLocator: $btLocator) {\n    externalStatusAllowed\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "1d924c53bbee21b03c0a3bae4745485f";

export default node;
